import React from 'react';
import { withRouter } from 'react-router';
import { Modal, Button } from 'antd';
import arrowsUps from '../../assets/img/arrows-up.svg';

function ModalEnhancedPlan(props) {
        const { showModal, onClick,email, history } = props;      
        const closeModal =() =>{
            onClick(false);         
        }
        
        const goToBuyLicense = () => {
            history.push(`/buy-license/user/${email}`);
        }

        return (
            <Modal
            visible={showModal}
            onCancel={closeModal}            
            zIndex={9999}
            footer={
                
                    <div style={{display:'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <Button type="primary" onClick={goToBuyLicense}>
                        Mejorar mi Plan
                        </Button>
                        <Button onClick={closeModal}>
                            Cerrar
                        </Button>   
                    </div>       
                        
            }
        >
            <figure style={{display:'flex', alignItems: 'center', justifyContent: 'center'}} >
                <img src={arrowsUps} />
            </figure>
            <h3 className="em text-center">¿Te gustaría renovar tu Plan?</h3>
            <p className="margin-0">Actualmente te encuentras en la versión gratuita. </p>
            <p className="margin-0">Mejora tu plan y aprovecha todo el potencial que efisco® tiene para ti:</p>
            <div style={{marginTop: '12px'}}>
                <p className="margin-0" >• Multi-RFC</p>
                <p className="margin-0" >• Mayor Volumen de descarga</p>
                <p className="margin-0" >• Validación de EFOS</p>
                <p className="margin-0" >• Generación de PDF</p>
                <p className="margin-0" >• Integración con Google Drive</p>
            </div>
        </Modal>		
        )
    }

export default withRouter(ModalEnhancedPlan)
